(function ($) {
  "use strict";
  	$( document ).ready(function() {
		
      	$('.template-index .site-header__menu.js-mobile-nav-toggle').on('click', function(){
          	if($(this).attr('aria-expanded') === 'true') {
          		$('.template-index #PageContainer').css('margin-top', '70px');
            } else {
            	$('.template-index #PageContainer').css('margin-top', '0');
            }
  		});
  	});
})(jQuery);